import { ROUTER_PATHS, TABLE_CONSTANTS_COLUMS, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { GeneralTable } from "@/shared/components/ui";
import { useTableColumnsOrdenServicioVisita } from "../../hooks/useTableColumnsOrdenServicioVisita";
import { useFetchAgendamientos } from "@/shared/actions/erp";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Agendamiento } from "@/shared/interfaces";

export type TableOrdenServicioVisitaProps = {
    estadoAgendamiento: string
}
export default function TableOrdenServicioVisita({ estadoAgendamiento }: TableOrdenServicioVisitaProps) {

    const navigate = useNavigate();

    const returnUrlAgendamientoPage = ROUTER_PATHS.operaciones.visitasAgendamientoPylNav;

    const {
        pagination,
        setPagination
    } = useTableFilter();

    const {
        pageIndex,
        pageSize
    } = pagination;

    const {
        filterObject,
        columnFilters,
        setColumnFilters
    } = useTableServerSideFiltering();

    const {
        columns
    } = useTableColumnsOrdenServicioVisita()

    const {
        data,
        isLoading,
        isRefetching
    } = useFetchAgendamientos({
        enabled: true,
        params: {
            page: pageIndex + 1,
            page_size: pageSize,
            ...filterObject,
            filterByState: false,
            estado_agendamiento_in: estadoAgendamiento,
            tipo_orden_servicio: 'VISITA'
        }
    })

    const onEdit = (value: Agendamiento) => {
        navigate(`${returnUrlAgendamientoPage}/${value.id_agendamiento}`);
    }

    return <>
        <GeneralTable<Agendamiento>
            columns={columns}
            data={data?.data?.data || []}
            isLoading={isLoading}
            isRefetching={isRefetching}
            //filter -server side
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableManualFiltering={true}
            //search
            enableGlobalFilter={false}
            //pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={data?.data?.count}
            //action
            enableColumnActions={true}
            enableEditing={true}
            canEdit={false}
            //crud
            showCustomActionBtnSpace={true}
            actionsColumnSize={TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL}
            customActionBtnSpace={(row) => {
                return <Grid container>
                    <Grid item>
                        <Tooltip title="Revisar visita">
                            <IconButton
                                onClick={() => onEdit(row)}
                            >
                                <Edit color="info" />
                            </IconButton>

                        </Tooltip>

                    </Grid>
                </Grid>
            }}
        />
    </>
}